import type { CursorState } from '../../types';
import { DomHelpers } from "@/utils/DomHelpers";

/**
 * Custom cursor in .no-artist section
 */
export class ArtistCursor {
  private readonly root: HTMLElement;
  private readonly cursor: HTMLElement;
  private state: CursorState;
  private rafId = 0;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(root: HTMLElement) {
    this.root = root;
    const c = root.querySelector<HTMLElement>('.cursor-title');
    if (!c) throw new Error('ArtistCursor: .cursor-title not found');
    this.cursor = c;
    const w = root.clientWidth / 2;
    const h = root.clientHeight / 2;
    this.state = { x: w, y: h, tx: w, ty: h, visible: false };
  }

  init(): void {
    if (!DomHelpers.hasHover()) return;

    const loop = (): void => {
      this.state.x = DomHelpers.lerp(this.state.x, this.state.tx, 0.18);
      this.state.y = DomHelpers.lerp(this.state.y, this.state.ty, 0.18);
      this.cursor.style.left = this.state.x + 'px';
      this.cursor.style.top = this.state.y + 'px';
      this.rafId = requestAnimationFrame(loop);
    };
    loop();

    this.root.addEventListener('mouseenter', this.show, { passive: true });
    this.root.addEventListener('mousemove', this.onMove, { passive: true });
    this.root.addEventListener('mouseleave', this.hide, { passive: true });

    window.addEventListener('resize', this.onResize, { passive: true });
  }

  private show = (): void => {
    if (this.hideTimer) clearTimeout(this.hideTimer);
    if (this.state.visible) return;
    this.state.visible = true;
    this.cursor.classList.add('is-show');
  };

  private hide = (): void => {
    this.state.visible = false;
    this.cursor.classList.remove('is-show');
    if (this.hideTimer) clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      const r = this.root.getBoundingClientRect();
      this.state.tx = r.width / 2;
      this.state.ty = r.height / 2;
    }, 380);
  };

  private onMove = (e: MouseEvent): void => {
    const r = this.root.getBoundingClientRect();
    this.state.tx = e.clientX - r.left;
    this.state.ty = e.clientY - r.top;
  };

  private onResize = (): void => {
    const r = this.root.getBoundingClientRect();
    if (!this.state.visible) {
      this.state.x = this.state.tx = r.width / 2;
      this.state.y = this.state.ty = r.height / 2;
      this.cursor.style.left = this.state.x + 'px';
      this.cursor.style.top = this.state.y + 'px';
    }
  };
}
